import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeaturePopupComponent } from './feature-popup.component';

@NgModule({
	imports: [CommonModule],
	declarations: [FeaturePopupComponent],
	exports: [FeaturePopupComponent],
})
export class FeaturePopupModule {}
